module.exports = __webpack_public_path__ + "static/media/shutterstock_478777894.3af6f9f8.jpg";